export const fetchConditionalPropertyRules = (objectTypeId, httpClient, query) => {
  return httpClient.get(`conditional-properties/v2/unified-rules`, {
    query: Object.assign({
      objectTypeId,
      pageSize: 100,
      includeActualConditionalPropertyRules: true
    }, query)
  }).then(response => {
    const {
      results,
      offset: newOffset,
      hasMore
    } = response;
    if (hasMore) {
      return fetchConditionalPropertyRules(objectTypeId, httpClient, Object.assign({}, query, {
        offset: newOffset
      })).then(rules => results.concat(rules));
    }
    return results;
  });
};